module.exports = __webpack_public_path__ + "static/media/Vcstartimg.f84b97f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Vcstartimg.png
// module id = 1179
// module chunks = 0